import { ARTICLES_PER_LOAD_DEFAULT } from 'utils/constants';

export const getNumberOfArticlesPerLoad = (numberOfArticlesPerLoad: number): number => {
  if (!numberOfArticlesPerLoad) return ARTICLES_PER_LOAD_DEFAULT;

  return numberOfArticlesPerLoad;
};
